'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var animationTime = 800;
var intervalTimeout = 10;
var widthVelocity = 110 * intervalTimeout / animationTime;

var targetReached = false;
var interval = void 0;
var loader = void 0;
var width = 0;
var target = 0;

var startInterval = function startInterval() {
    if (!loader) {
        loader = getLoader(document);

        if (!loader) {
            console.log('loader not found');
            return;
        }
    }

    if (!interval) {
        interval = setInterval(animateWidth, intervalTimeout);
    }
};

var animateWidth = function animateWidth() {
    if (width >= 100) {
        clearTimeout(interval);
        interval = null;
        loader.style.width = 0;
        width = 0;
        return;
    }

    if (width >= target && !targetReached) {
        targetReached = true;
    }

    width += !targetReached ? widthVelocity : widthVelocity / 50;

    loader.style.width = width + '%';
};

var TopLoaderService = function () {
    function TopLoaderService() {
        _classCallCheck(this, TopLoaderService);
    }

    _createClass(TopLoaderService, null, [{
        key: 'start',
        value: function start(percentage) {
            target = percentage || 35;
            startInterval();
        }
    }, {
        key: 'end',
        value: function end() {
            target = 200;
            targetReached = false;
        }
    }]);

    return TopLoaderService;
}();

exports.default = TopLoaderService;


var getLoader = function getLoader(document) {
    var loader = document.getElementById("progress");
    if (loader) return loader;

    loader = document.createElement('div');
    loader.setAttribute("id", "progress");
    loader.appendChild(document.createElement('b'));
    loader.appendChild(document.createElement('i'));
    document.body.appendChild(loader);

    return loader;
};